"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_warning.scss");

function Warning(a) {
  var b = a.text;
  return _react["default"].createElement("div", {
    className: "delete-confirmation-warning"
  }, _react["default"].createElement(_uiKit.ErrorIcon, null), _react["default"].createElement(_uiKit.Text, {
    noMargin: !0,
    label: !0
  }, b));
}

var _default = (0, _react.memo)(Warning);

exports["default"] = _default;